import { AwardLogo1 } from '@/components/icons/header/AwardLogo1';
import { AwardLogo2 } from '@/components/icons/header/AwardLogo2';
import { LogoIcon } from '@/components/icons/header/LogoIcon';
import { useOrientation } from '@/hooks/useOrientation';
import { useConfigStore } from '@/stores';
import { getLogoUrl } from '@/utils/logo';
import React from 'react';
import styles from './Header.module.scss';

export const Header: React.FC = () => {
    const { isHorizontal } = useOrientation();
    const buildingType = useConfigStore((state) => state.config?.server?.building?.buildingType);
    const contrast = useConfigStore((state) => state.config.ui.contrast);

    const logoUrl = getLogoUrl(isHorizontal, buildingType, contrast);

    return (
        <header className={styles['header']}>
            <div className={styles['header__content']}>
                <div className={styles['header__content__logo']}>
                    <div className={styles['footer__info__logo']}>{logoUrl ? <img src={logoUrl} alt="Logo" /> : <LogoIcon />}</div>
                </div>
                <div className={styles['header__content__award']}>
                    <AwardLogo1 />
                    <AwardLogo2 />
                </div>
            </div>
        </header>
    );
};
